export default __webpack_public_path__ + "static/media/fallout-hero-bg.6280be1e.png";